<template>
  <div>
    <component
        v-if="!errors.length"
        :is="widgetInstance"
        :config.sync="config"
        @config-update="widgetConfigUpdate"/>
    <div v-if="errors.length">
      Widget cannot be displayed because of following errors:
      <div v-for="e in errors">{{e}}</div>
    </div>
  </div>
</template>
<script>
  import {widgetByName} from "@/data/sources/widgetResolver"
  import {mergeWidgetConfig} from "../utils";

  export default {
    components: {},
    data() {
      return {
        widgetName: "",
        widgetInstance: null,
        config: {
          w: 2,
          h: 2,
          params: {},
        },
        errors: [],
      }
    },
    created() {
      const re = new RegExp("^\\w+$")
      Object.entries(this.$route.query).forEach(([key, value]) => {
        key = decodeURIComponent(key)
        value = decodeURIComponent(value)
        if (re.test(this.$route.query[key] || "")) {
          if (key === 'widgetName') {
            this.widgetName = this.$route.query.widgetName
          } else if (key === 'theme') {
            this.config.theme = value
          } else if (key === 'w') {
            this.config.w = value
          } else if (key === 'h') {
            this.config.h = value
          } else if (key === 'cType') {
            this.config.cType = value
          } else {
            this.config.params[key] = {value}
          }
        } else {
          try {
            const v = JSON.parse(value)
            this.config.params[key] = v
          } catch (e) {
            this.errors.push(`Invalid parameter ${encodeURIComponent(key)}: ${encodeURIComponent(this.$route.query[key] || "")}`)
          }
        }
        if (this.errors.length === 0) this.widgetInstance = widgetByName(this.widgetName)
      })
    },
    methods: {
      widgetConfigUpdate(update) {
        mergeWidgetConfig(this.config, update)
      }
    }
  }
</script>
